export enum URLS {
  FRONT_CFG = '/api/front/cfg',
  FRONT_API = '/front/api/core',
  CORE_API = '/api/core',
  WS_URL = '/channel',
}

export const OBJ_CODE_PATH = '/obj_code'
